// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-error[data-v-22965ae1]{\r\n  white-space: pre-line;\n}\r\n", ""]);
// Exports
module.exports = exports;
